import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { Col, Row } from 'reactstrap';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import useFilter from '../hooks/useFilter';

export default function WSRBCodes() {
    const axiosPrivate = useAxiosPrivate();
    const { filter } = useFilter();
    const [loading, setLoading] = useState(true);
    const [selectAll, setSelectAll] = useState(true);
    const [includeNullWSRBCodes, setIncludeNullWSRBCodes] = useState(true);
    const [selected, setSelected] = useState([]);
    const [customSelected, setCustomSelected] = useState([]);
    const [wsrbCodes, setWSRBCodes] = useState([]);
    const [allowNullWSRBCodesOption, setAllowNullWSRBCodesOption] = useState(true);

    useEffect(() => {
        const getWSRBCodes = async () => {
            if (allowNullWSRBCodesOption === true) {
                if (filter?.includeNullWSRBCodes === false) {
                    setIncludeNullWSRBCodes(filter.includeNullWSRBCodes);
                }
            }
            else {
                setIncludeNullWSRBCodes(false);
            }
            if (filter?.formCodes) {
                setWSRBCodes(filter.formCodes);
                if (filter?.wsrbCodes?.length == filter?.formCodes?.length || filter?.WSRBCodes?.length == filter?.formCodes?.length) {
                    setSelectAll(true);
                    setSelected(filter?.formCodes);
                }
                else {
                    setSelectAll(false);
                    var selected = filter?.formCodes.filter(code => filter?.wsrbCodes.includes(code.value))
                    setCustomSelected(selected);
                    setSelected(selected);
                }
            }
            else {
                try {
                    await axiosPrivate.get('/api/core/isocodes/wsrbcodes')
                        .then(response => {
                            var codes = response.data.map(wsrbcode => ({ value: wsrbcode.id, label: wsrbcode.code }));
                            setWSRBCodes(codes);
                            setSelected(codes);
                        });
                }
                catch (err) {
                    console.log(err);
                }
            }
        };
        getWSRBCodes().then(function () {
            setLoading(false);
        });
    }, []);

    const onChange = (value) => {
        setSelectAll(value);
        if (value == true) {
            setSelected(wsrbCodes);
        }
        else {
            setSelected(customSelected);
        }
    };

    const onSelectChange = (value) => {
        setCustomSelected(value);
        setSelected(value);
    };

    const onWSRBCodesCheckboxChange = (e) => {
        setIncludeNullWSRBCodes(e.target.checked);
    };

    return ({
        loading, selected, includeNullWSRBCodes, wsrbCodes, setAllowNullWSRBCodesOption,
        render:
            <Row>
                <Col xs="6">
                    <h5>WSRB Categories</h5>
                    {
                        allowNullWSRBCodesOption ?
                            <div>
                                <input type='checkbox' onChange={onWSRBCodesCheckboxChange} checked={includeNullWSRBCodes} /> Include Records With No WSRB Categories
                            </div>
                            :
                            null
                    }
                </Col>
                <Col xs="6">
                    <div>
                        <input className='radio-margin' type='radio' name='wsrbCodesRadio' onChange={() => onChange(true)} checked={selectAll} /> Select All
                        <input className='radio-margin' type='radio' name='wsrbCodesRadio' onChange={() => onChange(false)} checked={!selectAll} /> Custom Selection
                    </div>
                    <div>
                        {!selectAll ? <Select isMulti value={selected} options={wsrbCodes} onChange={onSelectChange} /> : null}
                    </div>
                </Col>
            </Row>
    });
}